
const enMessages = require('./en');


const locale = 'en';

function getLocalizedString(key) {
	let result = '';
  switch (locale) {
    case 'en':
      result = enMessages.getLocalizedString(key);
      break;
    default:
      break;
  }
	return result;
}


module.exports = {
  getLocalizedString
}



// WEBPACK FOOTER //
// ./src/locales/index.js